import * as TYPES from "./types";
import cloneDeep from 'lodash/cloneDeep';
import COMMON_DEFAULT_STATE from "./default-state";

export default function (state = cloneDeep(COMMON_DEFAULT_STATE), action) {

    switch (action.type) {
        case TYPES.INFO_REFRESH:
            return {...state, refreshing: action.refreshing};
        case TYPES.INFO_LOADED:
            return {...state, loaded: action.payload.loaded};
        case TYPES.INFO_SET:
            const scopedData = window.SEARCH_WIDGET_DATA || {};
            const userLoggedIn = !!window.userLoggedIn;
            const userCardType = window.userCardType || '';
            return {...state, refreshing: false, ...action.payload, ...scopedData, userLoggedIn, userCardType};
        case TYPES.INFO_GET_ERROR:
            return {...state, error: action.payload.error};
        default:
            return state;
    }
}
